import React from "react";
import { Link } from "react-router-dom";

export default function PageBanner({ title, subtitle, breadcrumbs = [], image = "/images/slider/slider3.jpg" }) {
  return (
    <section className="relative overflow-hidden overflow-x-clip bg-brand-ink" data-testid="page-banner">
      <div className="grain relative h-[300px] md:h-[380px] flex items-end">
        <div className="absolute inset-0 bg-cover bg-center animate-kenburns" style={{ backgroundImage: `url(${image})` }} />
        <div className="absolute inset-0 bg-gradient-to-t from-brand-ink via-brand-ink/80 to-brand-ink/35" />
        <div className="absolute inset-0 blueprint opacity-60" />
        <div className="glow pointer-events-none absolute -top-24 right-0 w-[560px] h-[560px] opacity-45" />
        <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10 pb-14 w-full">
          <div className="flex flex-wrap items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400 mb-5">
            <Link to="/" className="hover:text-brand-glow transition-colors duration-300">Anasayfa</Link>
            {breadcrumbs.map((b, i) => (
              <span key={i} className="flex items-center gap-2">
                <span className="text-white/25">/</span>
                {b.to ? (
                  <Link to={b.to} className="hover:text-brand-glow transition-colors duration-300">{b.label}</Link>
                ) : (
                  <span className="text-brand-glow/90 line-clamp-1">{b.label}</span>
                )}
              </span>
            ))}
          </div>
          <h1 className="font-display font-light text-3xl md:text-[2.7rem] text-white tracking-[-0.035em] leading-[1.12]">{title}</h1>
          {subtitle && <p className="mt-5 text-sm md:text-base text-slate-300/80 max-w-xl font-light leading-relaxed">{subtitle}</p>}
        </div>
      </div>
    </section>
  );
}
